// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"497bab75","98":"6f4baae5","147":"42b66f02","171":"1f9f3ab4","363":"f10f6b37","429":"e2383457","453":"dd8a874a","466":"93881788","507":"a8aed0a8","594":"90e5e0ac","780":"570b068b"}[chunkId] + ".chunk.js";
};